export const translationIT = {
  translation: {
    navBar: {
      title: {
        calendar: "Scegli le date",
        accommodation: "Sistemazione",
        extras: "Extra",
        summary: "Riepilogo",
        details: "Dettagli",
        payment: "Pagamento",
        success: "Conferma",
      },
    },
    cart: {
      title: {
        calendar: "Vai alle sistemazioni",
        accommodation: "Continua con gli extra",
        extras: "Rivedi la tua prenotazione",
        summary: "Inserisci i tuoi dati",
        details: "Continua al pagamento",
        payment: "Completa la prenotazione",
      },
      selectArrivalDate: "Per favore seleziona una data di arrivo",
      selectDepartureDate: "Per favore seleziona una data di partenza",
      priceFrom: "Da",
    },
    weekDays: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    months: [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre",
    ],
    shortMonths: [
      "Gen",
      "Feb",
      "Mar",
      "Apr",
      "Mag",
      "Giu",
      "Lug",
      "Ago",
      "Set",
      "Ott",
      "Nov",
      "Dic",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          description:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            { src: "see_the_top_hub.jpg", alt: "Guarda l'Hub superiore" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interno dell'Hub superiore",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Guarda l'Hub inferiore" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interno dell'Hub inferiore",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sì, puoi stare seduto nel letto",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Riproduci la tua musica via Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rinfrescati sotto la doccia a pioggia",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            { src: "hair_&_makeup_area.jpg", alt: "Area capelli e trucco" },
          ],
        },
        howManyTravellers: {
          title: "Quanti viaggiatori?",
          content:
            "Tutti i nostri spazi sono dotati di letti accoglienti, luci d'atmosfera e un tocco di tecnologia. L'unica domanda è: come preferisci soggiornare? <br /><br />I nostri Hub sono perfetti per chi viaggia da solo, per coppie o amici che desiderano privacy e un'atmosfera intima.<br /><br />Seleziona da 1 a 4 viaggiatori per vedere la variazione di prezzo.",
        },
        addAnotherAccomodation: {
          title: "Aggiungi Hub",
          hub: {
            title: "Hub",
            description:
              "Hub privato con letto king-size – perfetto per uno o due viaggiatori.",
          },
        },
      },
      CPH: {
        tags: ["Sauna in loco"],
        hub: {
          title: "Hub",
          excerpt:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          description:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            { src: "see_the_top_hub.jpg", alt: "Guarda l'Hub superiore" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interno dell'Hub superiore",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Guarda l'Hub inferiore" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interno dell'Hub inferiore",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "hallway.jpg", alt: "Corridoio" },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Goditi la nostra sauna",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          description:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Interno del Twin Hub superiore",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Interno del Twin Hub inferiore",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 materassi singoli con divisorio",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Goditi la nostra sauna",
            },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Serve più spazio? La Quad Room può ospitare fino a 4 viaggiatori. Ideale per amici o famiglie. Con bagno privato.",
          description:
            "Serve più spazio? La Quad Room può ospitare fino a 4 viaggiatori. Ideale per amici o famiglie. Con bagno privato. Adatta anche a persone con mobilità ridotta.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room con 4 letti a castello",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room con letto matrimoniale e 2 letti a castello",
            },
            { src: "private_bathroom.jpg", alt: "Bagno privato" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rinfrescati sotto la doccia a pioggia",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Goditi la nostra sauna",
            },
          ],
        },
        howManyTravellers: {
          title: "Quanti viaggiatori?",
          content:
            'Tutte le nostre sistemazioni offrono letti comodi, luci soffuse e un tocco di tecnologia. Come preferisci soggiornare? <ul className="list-disc p-4"><li>Viaggi da solo o in coppia e vuoi privacy? → Scegli un Hub.</li><li>Soggiornate insieme ma preferite letti separati? → Un Twin Hub è perfetto.</li><li>Cerchi più spazio con bagno privato? → Scegli la Quad Room.</li></ul>Qualunque sia la tua scelta, dormirai benissimo.<br />Seleziona 1 o 2 ospiti per vedere i prezzi.',
        },
        addAnotherAccomodation: {
          title: "Aggiungi un'altra sistemazione",
          hub: {
            title: "Hub",
            description: "Hub privato con letto king-size.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privato con due letti singoli e divisorio – ideale per amici.",
          },
          room: {
            title: "Quad Room",
            description:
              "Stanza privata con letti a castello e bagno privato – fino a 4 persone.",
          },
        },
      },
      RKV: {
        tags: ["Vasca idromassaggio in loco"],
        hub: {
          title: "Hub",
          excerpt:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          description:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            { src: "see_the_top_hub.jpg", alt: "Guarda l'Hub superiore" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interno dell'Hub superiore",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Guarda l'Hub inferiore" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interno dell'Hub inferiore",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sì, puoi stare seduto nel letto",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Rilassati nella nostra vasca idromassaggio sul tetto",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          description:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Interno del Twin Hub superiore",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Interno del Twin Hub inferiore",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 materassi singoli con divisorio",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Rilassati nella nostra vasca idromassaggio sul tetto",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Hub privato con letto king-size e grande schermo TV.",
          description:
            "Questa stanza compatta per 2 persone dispone di un letto king-size e di una grande TV. Ideale per il binge-watching direttamente dal tuo letto.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Grande TV per i tuoi programmi preferiti",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Rilassati nella nostra vasca idromassaggio sul tetto",
            },
          ],
        },
        howManyTravellers: {
          title: "Quanti viaggiatori?",
          content:
            'Tutte le nostre sistemazioni offrono letti comodi, luci d\'atmosfera e un tocco di tecnologia. Come preferisci soggiornare? <ul className="list-disc p-4"><li>Viaggi da solo o in coppia e vuoi privacy? → Scegli un Hub.</li><li>Soggiornate insieme ma preferite letti separati? → Un Twin Hub è perfetto.</li><li>Cerchi una stanza più tradizionale con TV (bagno condiviso)? → Scegli il Movie Hub.</li></ul>Qualunque sia la tua scelta, dormirai benissimo.<br />Seleziona 1 o 2 ospiti per vedere i prezzi.',
        },
        addAnotherAccomodation: {
          title: "Aggiungi un'altra sistemazione",
          hub: {
            title: "Hub",
            description:
              "Hub privato con letto king-size – perfetto per uno o due viaggiatori.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privato con 2 letti singoli e divisorio – ideale per amici.",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Stanza privata compatta con letto king-size e TV – fino a due viaggiatori.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          description:
            "Il tuo Hub privato per un massimo di 2 viaggiatori con un letto king-size. Perfetto per chi viaggia da solo, amici o coppie che amano il comfort.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            { src: "see_the_top_hub.jpg", alt: "Guarda l'Hub superiore" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interno dell'Hub superiore",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Guarda l'Hub inferiore" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interno dell'Hub inferiore",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sì, puoi stare seduto nel letto",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rinfrescati sotto la doccia a pioggia",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          description:
            "Stessa dimensione di un Hub, ma diviso in 2 materassi singoli con coperte separate e un divisorio. Ideale per 2 persone che desiderano il proprio spazio.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Un Hub è un'unità a forma di L",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Interno del Twin Hub inferiore",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Rilassati nel tuo letto king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Vai alle docce con i nostri kimono",
            },
            { src: "women_s_bathroom.jpg", alt: "Bagno donne" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Rinfrescati sotto la doccia a pioggia",
            },
            { src: "men_s_bathroom.jpg", alt: "Bagno uomini" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Prodotti Rituals gratuiti",
            },
          ],
        },
        howManyTravellers: {
          title: "Quanti viaggiatori?",
          content:
            'Tutte le nostre sistemazioni offrono letti comodi, luci soffuse e un tocco di tecnologia. Come preferisci soggiornare? <ul className="list-disc p-4"><li>Viaggi da solo o in coppia e vuoi privacy? → Scegli un Hub.</li><li>Soggiornate insieme ma preferite letti separati? → Un Twin Hub è perfetto.</li></ul>Qualunque sia la tua scelta, dormirai benissimo.<br />Seleziona 1 o 2 ospiti per vedere i prezzi.',
        },
        addAnotherAccomodation: {
          title: "Aggiungi un'altra sistemazione",
          hub: {
            title: "Hub",
            description:
              "Hub privato con letto king-size – perfetto per uno o due viaggiatori.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privato con due letti singoli e divisorio – ideale per amici.",
          },
        },
      },
      tags: {
        hub: [
          "Hub privato per 1-2 persone",
          "1 letto king-size",
          "Bagni condivisi",
          "Prodotti Rituals",
          "Asciugamani",
          "Kimono",
        ],
        twinHub: [
          "Hub privato per 2 persone",
          "2 materassi singoli con divisorio",
          "Bagni condivisi",
          "Prodotti Rituals",
          "Asciugamani",
          "Kimono",
        ],
        room: [
          "Stanza di 20 m² per 1-4 persone",
          "4 letti a castello o letto matrimoniale & 2 a castello",
          "Bagno privato",
          "Prodotti Rituals",
          "Asciugamani",
          "Kimono",
          "Accesso disabili",
        ],
        movieHub: [
          "Hub privato per 1-2 persone",
          "1 letto king-size",
          "Bagni condivisi",
          "Prodotti Rituals",
          "Asciugamani",
          "Kimono",
          "Televisione",
        ],
      },
      faq: {
        hub: [
          {
            q: "Hub superiore o inferiore? Posso scegliere?",
            a: "Sì. Un Hub è il tuo pod privato per dormire, a forma di L e pensato per 2 persone. Gli Hub sono impilati in coppia: uno in alto e uno in basso. Al check-in puoi scegliere se preferisci quello superiore o quello inferiore.",
          },
          {
            q: "Raccontami di più su questo Hub.",
            a: "Il tuo Hub di 6 m² è dotato di soluzioni di archiviazione intelligenti, prese di corrente e Wi-Fi. I letti sono già pronti al tuo arrivo. Puoi regolare le luci dell'Hub in base al tuo umore tramite l'app CityHub. Include lo streaming musicale Bluetooth.",
          },
          {
            q: "C'è l'aria condizionata nell'Hub?",
            a: "Sì, il tuo Hub è collegato a un sistema di climatizzazione centralizzato, regolato per garantire il massimo comfort alla maggior parte dei viaggiatori.",
          },
          {
            q: "Cosa posso aspettarmi dai bagni?",
            a: "Piuttosto lussuosi. Sono spazi condivisi, separati per uomini e donne, con docce a pioggia e prodotti di cortesia Rituals. Li manteniamo impeccabilmente puliti, tutto il giorno, ogni giorno.",
          },
          {
            q: "Devo portare i miei asciugamani?",
            a: "Abbiamo pensato a tutto per te. Asciugamani, saponi Rituals, shampoo, asciugacapelli e sì, c'è anche il ferro da stiro. Sai che abbiamo anche gli esclusivi kimono CityHub? Perfetti per raggiungere comodamente le docce. Ricorda però di portare le tue infradito.",
          },
          {
            q: "Posso venire con i bambini?",
            a: "Amiamo i bambini, davvero. Tuttavia, le nostre aree comuni non sono adatte a neonati o bambini sotto i 6 anni. Ti ricordiamo che ogni Hub può ospitare un massimo di 2 persone, bambini inclusi.",
          },
        ],
        twinHub: [
          {
            q: "Hub superiore o inferiore? Posso scegliere?",
            a: "Sì. Un Hub è il tuo pod privato per dormire, a forma di L e pensato per 2 persone. Gli Hub sono impilati in coppia. Al check-in puoi scegliere con il tuo CityHost se preferisci quello superiore o quello inferiore.",
          },
          {
            q: "Raccontami di più su questo Hub.",
            a: "Il tuo Hub di 6 m² dispone di archiviazione intelligente, prese e Wi-Fi. I letti sono pronti. Tramite l'app CityHub puoi regolare le luci. Streaming musicale Bluetooth incluso.",
          },
          {
            q: "C'è l'aria condizionata nell'Hub?",
            a: "Sì, il tuo Hub è collegato a un sistema di climatizzazione centralizzato impostato alla temperatura più confortevole.",
          },
          {
            q: "Cosa posso aspettarmi dai bagni?",
            a: "Piuttosto lussuosi. Condivisi ma separati, con docce a pioggia e prodotti Rituals gratuiti. Li manteniamo pulitissimi tutto il giorno.",
          },
          {
            q: "Devo portare i miei asciugamani?",
            a: "Abbiamo tutto noi: asciugamani, prodotti Rituals e kimono CityHub. Non dimenticare le infradito.",
          },
          {
            q: "Posso venire con i bambini?",
            a: "Amiamo i bambini, ma i nostri spazi condivisi non sono adatti a piccoli sotto i 6 anni. Un Hub ospita max 2 persone.",
          },
        ],
        room: [
          {
            q: "Raccontami di più sulla Quad Room.",
            a: "La tua Quad Room ha un bagno privato ed è dotata di prese e Wi-Fi. I letti sono pronti. Con l'app CityHub puoi regolare le luci. Streaming Bluetooth incluso.",
          },
          {
            q: "C'è l'aria condizionata nella Quad Room?",
            a: "Sì, la tua stanza è collegata a un sistema centralizzato per il massimo comfort.",
          },
          {
            q: "Devo portare i miei asciugamani?",
            a: "Troverai tutto qui: asciugamani, saponi Rituals, asciugacapelli e kimono CityHub. Porta solo le infradito.",
          },
          {
            q: "Posso venire con i bambini?",
            a: "Amiamo i bambini, davvero. Purtroppo, però, le nostre aree comuni non sono adatte a neonati o bambini molto piccoli sotto i 6 anni. Nota bene: una Quad Room può ospitare al massimo 4 persone. Questo include anche i bambini.",
          },
        ],
        movieHub: [
          {
            q: "Raccontami di più sul Movie Hub.",
            a: "Il tuo Movie Hub ha archiviazione intelligente, Wi-Fi e una grande TV. Letti pronti. Luci regolabili via app. Streaming musicale Bluetooth incluso.",
          },
          {
            q: "C'è l'aria condizionata nel Movie Hub?",
            a: "Sì, l'unità è collegata al sistema di climatizzazione centralizzato.",
          },
          {
            q: "Cosa posso aspettarmi dai bagni?",
            a: "Lussuosi bagni condivisi ma separati, con docce a pioggia e prodotti Rituals. Pulizia costante garantita.",
          },
          {
            q: "Devo portare i miei asciugamani?",
            a: "Troverai asciugamani, prodotti Rituals e kimono. Ricorda le infradito.",
          },
          {
            q: "Posso venire con i bambini?",
            a: "Amiamo i bambini, ma gli spazi comuni non sono adatti sotto i 6 anni. L'Hub ospita max 2 persone.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Scegli la città",
        button: { label: "Scegli città" },
      },
      selectCulture: {
        title: "Lingua e valuta",
        button: { label: "Salva modifiche" },
      },
      uspBar: {
        title: "Miglior prezzo garantito",
        content:
          "Ti garantiamo che prenotando tramite questo sito, otterrai sempre il miglior prezzo possibile.",
      },
    },
    component: {
      uspBar: {
        title: "Miglior prezzo garantito",
      },
    },
    scenes: {
      traveller_one: "viaggiatore",
      traveller_other: "viaggiatori",
      night_one: "notte",
      night_other: "notti",
      selectHotel: {
        chooseCity: "Prenota ora e scegli la tua città",
      },
      accommodation: {
        pricePerNight: "Prezzo per notte",
        pricePerNightInclVat: "Prezzo per notte (IVA incl.)",
        remove: "Rimuovi",
        directBookingDiscount: "Sconto prenotazione diretta",
        notAvailable: "non disponibile",
        unavailable: "Non disponibile",
        noMoreRoomsAvailable: "Prenota ora · ultima Hub",
        addAnotherRoom: "Aggiungi stanza",
        addAnotherHub: "Aggiungi Hub",
        howManyTravellers: "Quanti viaggiatori?",
        questions: "FAQ",
        moreTags_one: "tag extra",
        moreTags_other: "tag extra",
        more_info: "Più informazioni",
        not_available: "Non disponibile per questa data",
        show_more: "Più informazioni",
        show_less: "Meno informazioni",
        selected: "selezionato",
      },
      calendar: {
        startNotice: "{{hotelName}} apre le porte il {{startDate}}",
      },
      extras: {
        perPersonPerNight: "per persona, per notte",
        add: "Aggiungi",
        remove: "Rimuovi",
        moreInfo: "Più informazioni",
      },
      summary: {
        perNight: "/ notte",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "Tariffa:",
        discount: "Sconto:",
        from: "Da",
        before: "Entro",
        total: "Totale",
        incCityTax: "Tassa di soggiorno",
        incVat: "IVA incl.",
        incVatRooms: "IVA camere incl.",
        incVatProducts: "IVA prodotti incl.",
        directBookingDiscount: "Sconto prenotazione diretta",
        voucher: "Voucher",
        addVoucher: "Aggiungi un voucher",
        voucherInvalid: "Questo codice non è corretto",
        voucherNotApplicable: "Questo voucher non è valido per la tariffa selezionata",
      },
      details: {
        firstName: "Nome",
        firstNameRequired: "Il nome è obbligatorio",
        lastName: "Cognome",
        lastNameRequired: "Il cognome è obbligatorio",
        email: "Indirizzo email",
        emailRequired: "L'email è obbligatoria",
        emailInvalid: "L'email non è valida (deve contenere @ e un punto)",
        phoneMin: "Il telefono deve avere almeno 9 cifre",
        phoneInvalid: "Il telefono deve essere numerico",
        countryRequired: "Il paese è obbligatorio",
        phone: "Numero di telefono",
        country: "Paese",
        selectCountry: "Scegli il tuo paese",
        specialRequests: "Richieste speciali",
        terms:
          "Accetto i <firstLink>Termini e Condizioni</firstLink> e l'<secondLink>Informativa sulla Privacy</secondLink> della struttura.",
        marketingEmails: "Vorrei ricevere aggiornamenti periodici.",
        createReservation: "Prenota ora",
        finishPaymentAtKiosk: "Completa il pagamento al chiosco.",
        creatingReservation: "Creazione della prenotazione...",
        reservationCreated: "Prenotazione creata!",
        somethingWentWrong: "Qualcosa è andato storto, riprova.",
      },
      payment: {
        paymentMethods: "Metodi di pagamento",
        paymentMethodsDescription:
          "Ultimo passaggio. Completa il pagamento in modo sicuro. Utilizziamo sistemi criptati per proteggere i tuoi dati. Riceverai un'email di conferma.",
        authorizeCreditCard: "Autorizza la carta",
        cardChargeInfo: "L'addebito avverrà 48 ore prima dell'arrivo",
        securedWithMews: "Protetto da Mews Payments via PCI Proxy",
        payWithCreditCard: "Paga con carta di credito",
        payDirectly: "Paga direttamente",
        onlyVisaAndMastercardSupported: "Accettiamo solo Visa e MasterCard",
        nameOnCreditCard: "Nome sulla carta",
        cardNumber: "Numero carta",
        expirationDate: "Scadenza",
        expirationDateRequired: "La scadenza è obbligatoria",
        yearCanNotBeInThePast: "L'anno non può essere passato",
        yearCanNotBeMoreThan5YearsInTheFuture: "Max 5 anni nel futuro",
        monthCanNotBeInThePast: "Il mese non può essere passato",
        monthCanNotBeBiggerThan12: "Mese non valido",
        shouldBeAMonthAndAYear: "Formato MM/AAAA",
        validateCard: "Valida carta",
        createReservation: "Prenota ora",
        nameIsRequired: "Il nome è richiesto",
        cardNumberIsRequired: "Il numero è richiesto",
        invalidCardNumber: "Numero non valido",
        cvcIsRequired: "CVC richiesto",
        invalidCvc: "CVC non valido",
        somethingWentWrong: "Errore. Riprova più tardi.",
        somethingWentWrong4501: "Errore (4501). Riprova più tardi.",
        creatingReservation: "Creazione prenotazione...",
        reservationCreated: "Prenotazione effettuata!",
        finishPayment: "Finalizzazione pagamento...",
        creditcardNotAuthorizable: "Carta non autorizzabile",
      },
      success: {
        bookingConfirmed: "Prenotazione confermata!",
        bookingConfirmedDescription:
          "Il tuo soggiorno a {{hotelName}} è pronto. <br/>Check-in dalle 15:00. A presto! 👋",
        startChatting: "Inizia a chattare",
        viewBookingDetails: "Dettagli prenotazione",
        bookingDetails: "Dettagli prenotazione",
        whatsNext: "E adesso?",
        connectWithHost:
          "Contatta il tuo CityHost, il tuo riferimento h24 per consigli e segreti locali.",
        online: "ONLINE",
      },
      pageNotFound: {
        message: "Ops! <br />Pagina non trovata.",
        linkText: "Scegli l'hotel per iniziare",
      },
      redirectHotel: {
        message: "Caricamento configurazione...",
      },
      redirectPayment: {
        error4602: "[errore" + ":4602] Nessuna prenotazione",
        noPaymentsFound: "Nessun pagamento",
        paymentSuccessful: "Pagamento riuscito",
        paymentFailed: "Pagamento non riuscito",
        returningToSite: "Ritorno al sito...",
        authorizationPending: "Autorizzazione in sospeso",
        authorizationPendingMessage:
          "La prenotazione è stata creata, ma l'autorizzazione è ancora in sospeso.<br /><br />Clicca qui per autorizzare la carta.",
      },
    },
    form: {
      language: {
        label: "Lingua",
        placeholder: "Scegli lingua",
        options: {
          "en-US": "Inglese",
          "nl-NL": "Olandese",
          "de-DE": "Tedesco",
          "fr-FR": "Francese",
          "it-IT": "Italiano",
        },
        validation: { required: "La lingua è obbligatoria" },
      },
      currency: {
        label: "Valuta",
        placeholder: "Scegli valuta",
        options: {
          EUR: "Euro (€)",
          USD: "Dollaro US ($)",
          GBP: "Sterlina (£)",
          CAD: "Dollaro Canadese (C$)",
          DKK: "Corona Danese (DKK)",
          ISK: "Corona Islandese (ISK)",
        },
        validation: { required: "La valuta è obbligatoria" },
      },
    },
  },
};
